<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>股权设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            @node-click="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;">
        <el-button size="mini" @click="showShopDialog">分配股东门店股权</el-button>
        <el-date-picker
          v-if="authorities.includes('yield.reset')"
          v-model="resetMonth"
          type="month"
          size="mini"
          style="width: 150px;"
          placeholder="请选择重新生成月份"
          value-format="yyyy-MM"
        >
        </el-date-picker>
        <el-button size="mini" v-if="authorities.includes('yield.reset')" @click="resetCreateData">重新生成选择月数据</el-button>
        <el-table :data="userList" fit border stripe="stripe"
                  height="300px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" width="160">
            <template slot-scope="scope">
              <el-radio :label="scope.$index" v-model="selectUserId"  @change.native="selectUser(scope.row)">{{''}}</el-radio>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            label="股东名称" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="股东电话" >
          </el-table-column>
        </el-table>
        <br>
        <span style="font-size: 14px;color: #8c939d">门店股权列表</span>
        <el-table :data="yieldList" fit border stripe="stripe"
                  height="280px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}">
          <el-table-column
            align="center"
            label="操作" >
            <template slot-scope="scope">
              <el-link type="primary" icon="el-icon-edit"
                       style="padding-right: 10px" @click="showEditYieldDialog(scope.row)"></el-link>

            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="yieldDate"
            label="设置日期" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="shopName"
            label="股权门店" >
          </el-table-column>
          <el-table-column
            align="center"
            label="股权比例" >
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.rate" controls-position="right" size="mini"
                               :precision="2" :step="0.1"
                               @change="setRate" :min="0" :max="100"></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <el-button size="mini" @click="updateUserYield">确定</el-button>
      </div>

      <el-dialog
        title="选择股权门店"
        :visible.sync="shopVisible"
        width="50%"
        @close="closeShopDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <div style="display: flex;justify-content: space-around">
          <span>股东名称：{{selectedUser.userName}}</span>
          <span>股东电话：{{selectedUser.phone}}</span>
        </div>
        <div style=" height: 400px;display: flex;justify-items: center;justify-content: center">
          <el-transfer
            filterable ref="shopTransfer"
            :filter-method="filterMethod"
            filter-placeholder="请输入门店名称"
            style="height: 400px;" size="mini" :props="{key:'id', label:'orgName'}"
            v-model="selectedShops" :titles="['待选择门店','已选择门店']"
            :button-texts="['移除', '添加']"
            :data="shopList" @change="handleChange" clearQuery>
          </el-transfer>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeShopDialog">取 消</el-button>
        <el-button size="mini" @click="createUserYield">确 定</el-button>
      </span>
      </el-dialog>

      <el-dialog
        title="编辑股权"
        :visible.sync="editYieldDialogVisible"
        width="30%"
        style="position: absolute"
        @close="closeEditDialog"
        :close-on-click-modal="false"
      >
        <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
        <p>设置日期：</p>
        <el-date-picker
          v-model="editYield.yieldDate"
          type="date"
          size="mini"
          style="width: 150px;"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <p>股权门店：{{editYield.shopName}}</p>
        <p>股东比例：{{editYield.rate}}</p>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="closeEditDialog">取 消</el-button>
            <el-button size="mini" @click="editYieldMethod">确 定</el-button>
          </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId:'',
      userId:'',
      authorities:'',
      orgList: [],
      userList: [],
      yieldList: [],
      selectUserId:'',
      selectedUser:'',
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      userYield:{
        user:'',
        shopIds:[],
        creator:'',
      },
      shops:[],
      shopList:[],
      shopVisible:false,
      selectedShops:[],
      editYieldDialogVisible:false,
      editYield:{},
      resetMonth:''
    }
  },
  methods:{
    showEditYieldDialog(row){
      this.editYield = row
      this.editYieldDialogVisible = true;
    },
    closeEditDialog(){
      this.editYieldDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.selectedShops = val;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.selectUserId = '';
      this.loadUser(data.id);
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadUser(data){
      if (data !== ''){
        const {data:res} = await this.$http.get(`/org/users/${data}`);
        this.userList = res.data;
      }
    },
    selectUser(row){
      this.selectedUser = row;
      this.loadUserYield();
    },
    setRate(){

    },
    showShopDialog(){
      this.loadShops();
      // this.$nextTick(() => {
      //   this.$refs.shopTransfer.clearQuery('left')
      //   this.$refs.shopTransfer.clearQuery('right')
      // })
      this.shopVisible = true;
    },
    closeShopDialog(){
      this.shopVisible = false;
    },
    async loadShops(){
      this.shopList = [];
      this.selectedShops = [];
      const {data:res} = await this.$http.get(`/load/all/shops`)
      this.shopList = res.data;
    },
    filterMethod(query, item){
      return item.orgName.indexOf(query) > -1;
    },
    selectionShop(){
      this.closeShopDialog();
    },
    handleChange(value, direction, movedKeys){
      this.selectedShops = value;
    },
    async createUserYield(){
      this.userYield.user = this.selectedUser;
      this.userYield.shopIds = this.selectedShops;
      this.userYield.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/user/yield`, this.userYield);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }

      this.closeShopDialog();
      await this.loadUserYield();
    },
    async loadUserYield(){
      const {data:res} = await this.$http.get(`/user/yield/${this.selectedUser.id}`)
      this.yieldList = res.data;
    },
    async updateUserYield(){
      const {data:res} = await this.$http.post(`/update/user/yield/${this.userId}`, this.yieldList)
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadUserYield();
    },
    async editYieldMethod(){
      this.editYield.modifier = this.userId;
      const {data:res} = await this.$http.post(`/edit/user/yield/`, this.editYield)
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadUserYield();
      this.closeEditDialog();
    },
    async resetCreateData(){
      const {data:res} = await this.$http.get(`/reset/yield/data/${this.resetMonth}`)
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/.el-transfer-panel__body{
  height:450px;
}
/deep/.el-transfer-panel__list.is-filterable{
  height:500px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyYieldSet.vue